import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "../../styles/cards/card.css";
import PrimaryButton from "../buttons/PrimaryButton";
import Modal from "../modal/Modal";
import DatePickerComponent from "../datepicker/DatePicker";
import { useNavigate } from "react-router-dom";
import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";
import axios from "axios";
import Cookies from "js-cookie";

const AddScannedBook = ({ percentage, sector, siteId, district }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [doneAt, setDoneAt] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [siteData, setSiteData] = useState(null);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleDoneAtChange = (date) => {
    setDoneAt(date);
  };
  const handleButtonClick = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  const handleSubmitClick = () => {
    setShowModal(false);
    setShowConfirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const role = Cookies.get("role");
  
  const handleCardClick = () => {
    const basePath = role === 'SCANNER_ASSISTANT' ? '/scanner-assistant' : '/scanner-operator';
    sector ? (navigate(`${basePath}/${sector}`, { state: { siteId } }))
    : (navigate(`${basePath}/${district}`, { state: { siteId } }));
  };

  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        const token = Cookies.get("token");
        const res = await axios.get(`${baseUrl}/api/sites/${siteId}/approved`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSiteData(res.data);
      } catch (error) {
        setError("Failed to load site data");
      } finally {
        setLoading(false);
      }
    };

    fetchSiteData();
  }, [siteId, baseUrl]);


  return (
    <>
      <div
        className="new-site-container scanned-books-card"
        style={{ cursor: "pointer" }}
        onClick={handleCardClick}
      >
        <div className="percentage">{siteData?.completionRate ?? 0}%</div>
        <div className="sector-info">
          <div className="sector-name">{sector || district}</div>
          <div className="sector-label">{sector ? "Sector" : "District"}</div>
        </div>

        <div className="scanned-data">
          <div className="data-column">
            <div className="data-label">Scanned Books</div>
            <div className="data-value">{siteData?.scannedBooks ?? 0}</div>
          </div>
          <div className="line"></div>
          <div className="data-column">
            <div className="data-label">Scanned Records</div>
            <div className="data-value">{siteData?.scannedRecords ?? 0}</div>
          </div>
        </div>
        <div className="add-button">
          <PrimaryButton text="Add Scanned Books" onClick={handleCardClick} />
        </div>

        <Modal
          show={showConfirmationModal}
          onClose={handleCloseConfirmationModal}
        >
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">You have successfully submitted!</div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AddScannedBook;
